module.exports = __webpack_public_path__ + "img/banner.1c61246d.png";